import { defineComponent as f, createBlock as c, openBlock as t, withCtx as _, renderSlot as o, createElementBlock as i, createCommentVNode as l, createVNode as r, toDisplayString as p } from "vue";
import { _ as n } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { _ as b } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import { b as m } from "./baseMixins-HJffeBsS.js";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  key: 0,
  class: "arbo-label__prefix arbo__icon-btn"
}, x = {
  key: 0,
  class: "arbo-label__main"
}, h = {
  key: 0,
  class: "arbo-label__suffix arbo__icon-btn"
}, y = /* @__PURE__ */ f({
  __name: "Label.ce",
  props: {
    ...m,
    prefixIcon: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Here is label"
    },
    tooltipLabel: {
      type: String,
      default: ""
    }
  },
  setup(s) {
    const e = s;
    return (a, g) => (t(), c(b, {
      class: "arbo-label",
      content: e.tooltipLabel,
      delay: [300, 0]
    }, {
      default: _(() => [
        o(a.$slots, "prefix", {
          prefixIcon: e.prefixIcon
        }, () => [
          e.prefixIcon ? (t(), i("div", u, [
            r(n, {
              class: "arbo-label__prefix--icon",
              name: e.prefixIcon
            }, null, 8, ["name"])
          ])) : l("", !0)
        ], !0),
        o(a.$slots, "default", {}, () => [
          e.label ? (t(), i("div", x, p(e.label), 1)) : l("", !0)
        ], !0),
        o(a.$slots, "suffix", {
          suffixIcon: e.suffixIcon
        }, () => [
          e.suffixIcon ? (t(), i("div", h, [
            r(n, {
              class: "arbo-label__prefix--icon",
              name: e.suffixIcon
            }, null, 8, ["name"])
          ])) : l("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["content"]));
  }
}), I = ".arbo-label[data-v-755e58f1]{display:flex;align-items:center}.arbo-label__main[data-v-755e58f1]{font-weight:inherit;font-size:inherit;color:inherit;line-height:inherit}.arbo-label__prefix[data-v-755e58f1],.arbo-label__suffix[data-v-755e58f1]{max-width:32px;max-height:32px;object-fit:contain;display:flex;align-items:center;color:#000}", w = /* @__PURE__ */ d(y, [["styles", [I]], ["__scopeId", "data-v-755e58f1"]]);
export {
  w as default
};
